define( function() {
	"use strict";

	return Date.now();
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/ajax/var/nonce.js
// module id = zpla
// module chunks = 0 1